// /src/pages/StatsOverviewPage.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { getLangFromPath } from "../i18n/lang";

import StatsOverviewUk from "./static/StatsOverviewPage.uk.jsx";
import StatsOverviewEn from "./static/StatsOverviewPage.en.jsx";
import StatsOverviewIt from "./static/StatsOverviewPage.it.jsx";
import StatsOverviewFr from "./static/StatsOverviewPage.fr.jsx";

export default function StatsOverviewPage(props) {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname) || "uk";

  React.useEffect(() => {
    const hash = (loc.hash || "").replace(/^#/, "");
    if (hash) {
      const el = document.getElementById(hash);
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [loc.hash]);

  const Map = {
    uk: StatsOverviewUk,
    en: StatsOverviewEn,
    it: StatsOverviewIt,
    fr: StatsOverviewFr,
  };

  const L = Map[lang] || StatsOverviewUk;
  return <L {...props} />;
}
